export const environment = {
  production: false,
  register_api: 'http://api.register.dev.broadfactor.com/',
  broad_website: 'https://new.dev.broadfactor.com/'
}
